import * as React from 'react';
import { useTheme } from '@mui/material';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useTranslation } from 'react-i18next';

interface NotificationSettingsProps {
  handleOpenDialog: (event: React.MouseEvent<HTMLElement>) => void;
}

export default function NotificationSettings(props: NotificationSettingsProps) {
  const { handleOpenDialog } = props;
  const theme = useTheme();
  const { t } = useTranslation('account');

  return (
    <ListItem disablePadding>
      <ListItemButton onClick={handleOpenDialog} data-id="notification-settings">
        <ListItemIcon>
          <theme.icons.notificationEdit fontSize="small" />
        </ListItemIcon>
        <ListItemText primary={t('menu.notifications')} />
      </ListItemButton>
    </ListItem>
  );
}
